export const TEMPLATE_DOWNLOADS = [
	{
		filename: '§605-adverse-event.md',
		label: '§605 - Serious Adverse Event Intake & Reporting',
	},
	{
		filename: '§606-gmp-prep.md',
		label: '§606 - Good Manufacturing Practice Preparation',
	},
	{
		filename: '§607-facility-registration.md',
		label: '§607 - Facility Registration',
	},
	{
		filename: '§607-product-listing.md',
		label: '§607 - Product Listing',
	},
	{
		filename: '§608-safety-substantiation.md',
		label: '§608 - Safety Substantiation',
	},
	{
		filename: '§609-label-governance.md',
		label: '§609 - Label Governance',
	},
	{
		filename: '§610-records-access.md',
		label: '§610 - Records Access',
	},
	{
		filename: '§611-recall-management.md',
		label: '§611 - Recall Management',
	},
	{
		filename: '§605-612-training-documentation.md',
		label: '§605–§612 - Training & Documentation Control',
	},
	{
		filename: '§605-612-supplier-oversight.md',
		label: '§605–§612 - Supplier Oversight',
	},
	{
		filename: '§605-612-regulatory-watch.md',
		label: '§605–§612 - Regulatory Monitoring & Change Control',
	},
] as const
